import { Textarea } from "@/modern/components/ui/textarea";
import { cn } from "@/modern/utils";

interface MarketingContentDescriptionProps {
  caption: string;
  altText: string;
  onCaptionChange: (value: string) => void;
  onAltTextChange: (value: string) => void;
  captionMaxLength?: number;
  captionError?: string;
  altTextError?: string;
  required?: boolean;
}

export const MarketingContentDescription = ({
  caption,
  altText,
  onCaptionChange,
  onAltTextChange,
  captionMaxLength,
  captionError,
  altTextError,
  required,
}: MarketingContentDescriptionProps) => (
  <div className="space-y-4">
    <div>
      <label className="text-sm font-semibold uppercase tracking-wide text-muted-foreground mb-1.5 block">
        Caption {required && <span className="text-destructive">*</span>}
      </label>
      <Textarea
        value={caption}
        onChange={(e) => onCaptionChange(e.target.value)}
        rows={3}
        maxLength={captionMaxLength}
        className={cn("resize-y text-sm", captionError && "border-destructive focus-visible:ring-destructive")}
        placeholder="Enter a descriptive caption..."
      />
      {captionMaxLength && (
        <span
          className={cn(
            "text-xs mt-1.5 block text-right",
            caption.length > captionMaxLength * 0.9 ? "text-amber-500" : "text-muted-foreground/60",
          )}
        >
          {caption.length} / {captionMaxLength} characters
        </span>
      )}
      {captionError && <p className="text-sm text-destructive mt-1">{captionError}</p>}
    </div>

    <div>
      <label className="text-sm font-semibold uppercase tracking-wide text-muted-foreground mb-1.5 block">
        Alt Text {required && <span className="text-destructive">*</span>}
      </label>
      <Textarea
        value={altText}
        onChange={(e) => onAltTextChange(e.target.value)}
        rows={2}
        className={cn("resize-y text-sm", altTextError && "border-destructive focus-visible:ring-destructive")}
        placeholder="Enter alt text for accessibility..."
      />
      <span className="text-xs text-muted-foreground/60 mt-1 block">
        Used for accessibility and search indexing.
      </span>
      {altTextError && <p className="text-sm text-destructive mt-1">{altTextError}</p>}
    </div>
  </div>
);
